import { makeUserSessionsRepository } from 'modules/authentication/infra/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import PerformDocumentLoginUseCase from './implementations/PerformDocumentLoginUseCase';

let instance: PerformDocumentLoginUseCase | null = null;

export default function makePerformDocumentLoginUseCase() {
  if (!instance) {
    const sessionsRepository = makeUserSessionsRepository();
    const httpProvider = makeHTTPProvider();

    instance = new PerformDocumentLoginUseCase(
      sessionsRepository,
      httpProvider,
    );
  }

  return instance;
}
